<template>
	<v-menu offset-y content-class="grv-menu" max-height="400px">
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="on"
				:loading="loading"
				color="background darken-1"
				:disabled="jds.length === 0"
				class="text-none ma-0 freq-btn"
				@click="getUserJds()">
				<v-icon large>person_outline</v-icon>
				<v-icon
					size="20"
					style="margin-top: -10px; margin-left: -8px; margin-right: 4px;">
					schedule
				</v-icon>
			</v-btn>
		</template>
		<v-list dense class="pa-0 background darken-1">
			<template v-for="jd in user_top_jds">
				<v-list-tile :key="jd.name"
					:style="`border-top: 0.5px solid ${$colors.stringToHsl(jd.name, 70)};
									border-left: 4px solid ${$colors.stringToHsl(jd.name, 70)};
									color: ${$colors.stringToHsl(jd.name, 70)};`"
					@click="$emit('select-jd', jd.id)">
					<v-list-tile-title>{{ jd.name }}</v-list-tile-title>
				</v-list-tile>
			</template>
		</v-list>
	</v-menu>
</template>

<script>
const MAX_CALL_PERIOD = 10000
export default {
	props: [ 'jds' ],
	data () {
		return {
			user_top_jds: [],
			loading: false,
			last_call: null
		}
	},
	computed: {
		user () {
			return this.$store.getters.user
		}
	},
	methods: {
		getUserJds () {
			let now = Date.now()
			if (!this.last_call) {
				this.last_call = now
			} else if (now - this.last_call < MAX_CALL_PERIOD) {
				return
			}
			this.loading = true
			this.$EsMaestro.user_jobdescriptors(this.user.maestroUserId, 10, 10)
				.then(results => {
					let userTopJds = []
					results.jds.map(result => {
						userTopJds.push({
							name: result.label,
							id: result.id
						})
					})
					this.user_top_jds = userTopJds
					this.last_call = Date.now()
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_frequent_jds.vue